module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resume-section-item-container"
  }, _vm._l((_vm.content), function(item) {
    return _c('div', {
      key: item.id
    }, [(item.content) ? _c('div', [_c('i', [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.content) ? _c('resume-section-item', {
      attrs: {
        "content": item.content
      }
    }) : _vm._e()], 1) : _c('ul', {
      staticClass: "item-body"
    }, [_c('span', {
      staticClass: "item-body-title"
    }, [_vm._v("\n        " + _vm._s(item.title) + "\n      ")]), _vm._v(" "), _vm._l((item.body), function(body) {
      return _c('li', {
        key: body
      }, [_vm._v("\n        " + _vm._s(body) + "\n      ")])
    })], 2)])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50282bb2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/resume-section-item.vue
// module id = 289
// module chunks = 0